import { Link, useLocation } from "react-router-dom";
import { Mail, MessageCircle, ArrowUpRight } from "lucide-react";
import { useSettings, FALLBACK_EMAIL } from "@/lib/api";

const waLink = (n) => `https://wa.me/${String(n).replace(/[^0-9]/g, "")}`;

export const MobileCTA = () => {
  const s = useSettings();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const email = s.contact_email || FALLBACK_EMAIL;
  return (
    <>
      <div data-testid="mobile-sticky-cta" className="fixed inset-x-3 bottom-2 z-40 flex items-center gap-1.5 rounded-full border border-white/10 bg-[#13052A]/90 p-1 shadow-2xl backdrop-blur-xl md:hidden">
        <Link to="/contact?type=audit" data-testid="mobile-sticky-audit" className="btn-accent min-h-[44px] flex-1 !py-2.5">Free Digital Audit <ArrowUpRight className="h-4 w-4" /></Link>
        <a href={`mailto:${email}`} aria-label="Email Freya" data-testid="mobile-sticky-email" className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white"><Mail className="h-5 w-5" /></a>
        {s.whatsapp_number && (
          <a href={waLink(s.whatsapp_number)} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="mobile-sticky-whatsapp" className="flex h-11 w-11 items-center justify-center rounded-full bg-[#25D366] text-white"><MessageCircle className="h-5 w-5" /></a>
        )}
      </div>
      {s.whatsapp_number && (
        <a href={waLink(s.whatsapp_number)} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp" data-testid="whatsapp-float"
          className="fixed bottom-6 right-6 z-40 hidden rounded-full bg-[#25D366] p-4 text-white shadow-xl transition-transform hover:scale-105 md:block">
          <MessageCircle className="h-6 w-6" />
        </a>
      )}
    </>
  );
};
